module.exports = __webpack_public_path__ + "13eb495f5e8730b39fcf67c2a5585a38.png";